module.exports = __webpack_public_path__ + "img/img-3-4mobile.4c3531bd.png";